import React from 'react';
import Header from './Header';
import Footer from './Footer';
import MobileActionBar from '../MobileActionBar';

const Layout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Header />
      <main className="flex-1 pb-16 md:pb-0">
        {children}
      </main>
      <Footer />
      <MobileActionBar />
    </div>
  );
};

export default Layout;
